import { type FC } from "react";
import { GraphCassette } from "../GraphCassette";
import { type GraphCassetteProps } from "../../type";
import * as styles from "./styles.css";

type Props = {
  resultDetails: GraphCassetteProps[];
  className?: string;
};

export const GraphCassettes: FC<Props> = ({ resultDetails, className }) => {
  const sortedDetails = [...resultDetails].sort((a, b) => a.result.rankNum - b.result.rankNum);
  return (
    <div className={`${styles.outer} ${className ?? ""}`}>
      {sortedDetails.map((detail) => (
        <GraphCassette key={detail.resultType} {...detail} className={styles.cassette} />
      ))}
    </div>
  );
};
